module.exports = __webpack_public_path__ + "img/icon_button_woda.734b76d3.svg";